import reducer from './reducers/index.js'
import { saveEntity, deleteEntity } from './actions/ClientActions.js'

export const actions = {
  saveEntity,
  deleteEntity,
}

export { selectors } from './reducers/index.js'
export default reducer
